import { render, staticRenderFns } from "./memberTabIndex.vue?vue&type=template&id=c3296784"
import script from "./memberTabIndex.vue?vue&type=script&lang=js"
export * from "./memberTabIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports